import React from 'react';
import Photo from './general/Augium-icon.png';

const AugiumIcon = () => {
    return <img src={Photo} alt="Augium Icon" className="augium-web-icon" title="Logo" />
};
export { AugiumIcon };